var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUnlocking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_unlocking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_unlocking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#005082",
    fill: "#FFFFFF",
    cx: 9,
    cy: 9,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9798,5 C7.8858,5 6.9998,5.886 6.9998,6.98 L7,8 L8,8 L7.9998,6.99 C7.9998,6.443 8.4428,6 8.9898,6 L9.0098,6 C9.5568,6 9.9998,6.443 9.9998,6.99 L10,11 L11,11 L10.9998,6.98 C10.9998,5.886 10.1138,5 9.0198,5 L8.9798,5 Z",
    id: "Fill-4",
    fill: "#005082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10 L8,10 L7,10 C6.448,10 6,10.448 6,11 L6,13.0010434 C6,13.5527519 6.45097518,14 6.99077797,14 L11.009222,14 C11.5564136,14 12,13.5573397 12,13.0010434 L12,11 C12,10.448 11.552,10 11,10 L10,10 Z",
    id: "Fill-1",
    fill: "#005082"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlocking);
export default __webpack_public_path__ + "static/media/icon_unlocking.bdbc6a3279d7d2d3cb05b637e60a096b.svg";
export { ForwardRef as ReactComponent };